import { render, staticRenderFns } from "./ApplicantCandidatureConf.vue?vue&type=template&id=5bf089bc"
import script from "./ApplicantCandidatureConf.vue?vue&type=script&lang=js"
export * from "./ApplicantCandidatureConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports